import { langArr } from "../translation/language"

export const acceptedLang = (lang) => {
  if (lang?.toLowerCase() in langArr) {
    return true;
  }

  return false;
}
